import React, { Component  } from 'react';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import axios from "axios"
import Tooltip from '@material-ui/core/Tooltip';
import Modal from '@material-ui/core/Modal';



export default class StatutPaiements extends Component {
  paiements(){
    axios.post("/api/v1/experts/app/paiements/paiements",{id: this.props.demande}).then((data)=>{
      this.setState({
        paiements: data.data
      })
    })
  }
  constructor(props) {
    super(props);
    this.paiements        = this.paiements.bind(this)
    this.handleExpertPaid = this.handleExpertPaid.bind(this)
    this.openModal = this.openModal.bind(this)
    this.state = {
      paiements: [],
      modal: false,
      promo: "",
      btnClass: "",
      paiement: ""
    };
    this.paiements()
  }
  handleExpertPaid(e){
    e.preventDefault()
    this.setState({btnClass: "disabled"})
    axios.post("/api/v1/experts/app/paiements/set_paid",{id: this.props.demande,paiement: this.state.paiement,promo: this.state.promo}).then((data)=>{
      this.paiements()
      this.setState({modal: false, promo: "",btnClass: "",paiement: ""})
    })
  }
  openModal(e){
    e.preventDefault()
    this.setState({modal: true,paiement: e.target.dataset.paiement})
  }
  render() {
    return (
      <div className="container">
      <h1 className="center">Paiements</h1>
      {this.state.paiements.length==0 ? (
          <p className="center"><i>Aucun paiement n'est en cours.</i></p>
        ) : (<div></div>)}
      {this.state.paiements.map((paiement,index)=>(
          <div key={index} className={"card paid-"+paiement.paid}>
            <div className="card-content row">
              <div className="col s4">
                  {paiement.nom} | {paiement.email}
              </div>
              <div className="col s3">{paiement.titre} | {paiement.price}€</div>
            <div className="col s5">
              {paiement.paid ? (
                  <p className="center">Paiement payé</p>
                ) : (
                  <div>
                    <p className="center">Paiement non payé</p>
                    <div className="row">
                      <div className="col s3">
                      <CopyToClipboard text={paiement.lien}>
                        <Tooltip title="Copier l'ul de paiement" aria-label="add">
                          <i className="material-icons copy-link">content_paste</i>
                        </Tooltip>
                      </CopyToClipboard>
                      </div>
                      <div className="col s7">
                        <Tooltip title="En cliquant ici, le montant sera débité du compte de l'EXPERT" aria-label="add">
                          <a href="" onClick={this.openModal} data-paiement={paiement.id} className={"btn blue white-text right "+this.state.btnClass}><i className="material-icons left">done</i>Payer</a>
                        </Tooltip>
                      </div>
                    </div>
                  </div>
                )}
            </div>
            </div>

             <Modal
               open={this.state.modal}
               onClose={()=>this.setState({modal: false})}
               aria-labelledby="Modal paiement"
               aria-describedby="simple-modal-description"
              >
              <div className="modal" style={{marginTop: "8vh",display: "block",paddingBottom: "15px"}}>
              <div className="modal-content">
                  <h1 className="center">Valider le paiement par expert</h1>
                  <p className="center">En validant , le montant de la comission sera déduit de votre compte, par conséquent soyez bien payé avant par le client.</p>
                  <h2 className="center">Code promo</h2>
                   <p className="center">Si vous possédez un code promotionnelle, entrez le ici afin d'avoir les frais offert.</p>
                  <div className="container">
                    <div className="input-field">
                        <input type="text" value={this.state.promo} onChange={(e)=>this.setState({promo: e.target.value})} />
                        <label htmlFor="text">Code promo</label>
                    </div>
                  <a href="" onClick={this.handleExpertPaid} data-paiement={this.state.paiement} className={"btn blue white-text right "+this.state.btnClass}><i className="material-icons left">done</i>Payer</a>
                  <p></p>
                  </div>
             </div>
             </div>
             </Modal>
          </div>
        ))}

      </div>
    );
  }
}
